import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, styled } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { LinkUnstyled, ICONS, unit, COLORS } from '@hcr/ui'
import { isNotUndefined } from '@hcr/utils'

import { useUserDetails } from '../../../../../contexts'
import { Path } from '../../../../../models'
import { to } from '../../../../../utils'

export const NavigationAccountButton: FC = () => {
  const userDetails = useUserDetails()
  const { t } = useTranslation()

  return (
    <AccountButton component={LinkUnstyled} to={to(Path.Account)} aria-label={t('navigation.account')}>
      <AccountIcon>
        <FontAwesomeIcon size='lg' color={COLORS.burgundi[500]} icon={ICONS.fasUser} />
      </AccountIcon>

      {userDetails.isSuccess && isNotUndefined(userDetails.data) && userDetails.data.first_name}
    </AccountButton>
  )
}

const AccountIcon = styled(Box)`
  color: ${COLORS.white};
  font-size: ${unit(3)};
  font-weight: initial;
  width: ${unit(8)};
  height: ${unit(8)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.burgundi[100]};
  border-radius: ${unit(4)};
  padding: ${unit(1)};
`

const AccountButton = styled(Button)`
  display: inline-flex;
  gap: ${unit(1.5)};
  color: ${COLORS.white};
  font-size: ${unit(3)};
  font-weight: initial;
  width: fit-content;
  height: 100%;
  padding: 0 ${unit(3.75)};
  justify-content: start;

  &:hover {
    color: ${COLORS.burgundi[200]};

    .MuiBox-root {
      background-color: ${COLORS.burgundi[200]};
    }
  }
` as typeof Button
